import React from 'react'

import {Grid, withStyles} from '@material-ui/core'
import VoucherButtons from '../VoucherButtons'
import styles from './styles'

/**
 * These are the buttons that are displayed at the bottom of the Offline Payment Feedback page.
 *
 * @param classes: {Object} containing the JSS classes for the current component to use.
 * @param printVoucher: {Function} invoked when the user pressed the Print button.
 * @param downloadVoucher: {Function} invoked when the user clicked the Download button.
 * @param formData: {Object} containing form data.
 */
const OfflineVoucherButtons = ({classes, printVoucher, downloadVoucher, formData}) => (
  <Grid container justify={"center"}>
    <Grid item xs={12}>
        <VoucherButtons
            printVoucher={printVoucher}
            downloadVoucher={downloadVoucher}/>
    </Grid>

    <Grid item xs={"auto"} className={classes.finalizeContainer}>
        <a href={formData.successUrl} className={classes.finalize}>
            Finalizar
        </a>
    </Grid>
  </Grid>
)

const Styled = withStyles(styles)(OfflineVoucherButtons)

export default Styled
